import React, { Component } from 'react';
import { connect, Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { applyRouterMiddleware, Router } from 'react-router';
import { useScroll } from 'react-router-scroll';

import { AlertRoot, LogRoot, StatusRoot } from 'components/common/AriaLive';
import { setupHolmes } from 'actions/holmes';
import { routeUpdateComplete } from 'actions/pageView';
import marketplace from 'cfg/marketplace.json';
import shouldScrollToTopFactory from 'helpers/shouldScrollToTop';
import MartyContextProvider from 'containers/MartyContextProvider';

const scrollToTopDecider = shouldScrollToTopFactory(marketplace.features.pageTransitionScrollTarget);

export class Root extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    routes: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ]).isRequired,
    store: PropTypes.object.isRequired
  };

  static defaultProps = {
    onEnter: () => null
  };

  componentDidMount() {
    this.props.setupHolmes();
  }

  onUpdate = () => {
    this.props.store.dispatch(routeUpdateComplete());
  };

  render() {
    const { store, history, routes, canUseScroll, renderProps, onEnter, environmentConfig } = this.props;
    const routerProps = { history };
    if (canUseScroll) {
      routerProps.render = applyRouterMiddleware(useScroll(scrollToTopDecider));
    }

    return <>
      <Provider key={Math.random()} store={store}>
        <MartyContextProvider history={history} environmentConfig={environmentConfig}>
          <Router
            {...renderProps}
            {...routerProps}
            onUpdate={this.onUpdate}
            onEnter={onEnter}>
            {routes}
          </Router>
        </MartyContextProvider>
      </Provider>
      <AlertRoot />
      <StatusRoot />
      <LogRoot />
    </>;
  }
}

export default connect(undefined, { setupHolmes })(Root);
